import * as React from "react";
import { SiteModel } from "src/model/model";
import { observer } from "mobx-react-lite";
import { useEffect, useRef } from "react";
import { fetchArticles, getArticleCount } from "src/modules/sanityApi";
import { SchemaType } from "src/modules/sanityApi";
import LoadingSpinner from "src/components/loading";
import { SanityImage } from "sanity-image";
import { toHTML } from "@portabletext/to-html";
import "src/styles/timeline.css";
import { PageTitle } from "src/components/pageTitle";
import { toJS } from "mobx";
import YouTube from "react-youtube";
// /// <reference types="vite-plugin-svgr/client" />
// import TapeSVG from "src/svg/scotchTape.svg?react";

export const Timeline = observer(({session}: {session: SiteModel}) => {

    useEffect(() => {
        const fetchPosts = async () => {
            if (!session.timelineHasLoaded) {
                try {
                    session.setTotalAvailableTimelineEntries(await getArticleCount(SchemaType.TimelineEntry))
                    console.log("No timeline entries loaded, fetching...");
                    const fetchedPosts = await fetchArticles(SchemaType.TimelineEntry);
                    session.addTimelineEntries(fetchedPosts);
                } catch (error) {
                    console.error("Error fetching posts:", error);
                }
            }
        };

        fetchPosts();
    }, [session]);

    async function onLoadMoreACB(){
        if (session.allArticlesLoaded) return;
        try {
            const fetchedPosts = await fetchArticles(SchemaType.TimelineEntry, 10, session.lastEntryDate, session.lastEntryId);
            session.addTimelineEntries(fetchedPosts);
        } catch (error) {
            console.error("Error fetching posts:", error);
        }
    }

    return (
        <TimelineView
        timelineEntries={session.timelineEntries}
        onLoadMore={onLoadMoreACB}
        showLoadMore={session.numberOfTimelineEntries < session.totalAvailableTimelineEntries}
        />
    );
});

function TimelineEntry(props){
    const style = {}
    if (props.idol) style["--color-main"] = `var(--${props.idol.toLowerCase()}_font)`;
    return (
        <div className="timeline-entry" style={style}>
        {props.image &&
            <div className="timeline-image-wrapper">
            <SanityImage // TODO: This image gets fetched every time, which is kinda bad. Store it to application state or something.
                id={props.image.asset._ref} 
                projectId="47i27g55" 
                dataset="production"
                // width={200}
                height={500} // makes images smaller leading to less data being used
                mode="cover"
                className={(props.imageStyle && props.imageStyle !== "none") ? `timeline-image-${props.imageStyle}` : undefined}
            />
            </div>
        }

        {props.videoId &&
            <YouTube
            className={"timeline-video-wrapper"}
            videoId={props.videoId}
            opts={{}}
            />
        }
        
        <div className="timeline-text-wrapper">
            <span className="timeline-title">{props.title}</span>
            <p className="timeline-description" dangerouslySetInnerHTML={{__html: props.body}}/>
            <p className="timeline-date">{props.date}</p>
        </div>
        </div>
    )
}

function TimelineView(props){
    function debounce(func, delay) {
        let timeoutId;
        return function (...args) {
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          timeoutId = setTimeout(() => {
            func(...args);
          }, delay);
        };
      }

    useEffect(() => {
          window.addEventListener("scroll", debounce(handleScroll, 500));
    
          // Clean-up
          return () => {
            window.removeEventListener("scroll", debounce(handleScroll, 500));
          };
      }, []);

    const handleScroll = () => {
        if (document.body.scrollHeight - 300 < window.scrollY + window.innerHeight) {
            props.onLoadMore();
        }
    };

    return (<>
    <PageTitle pageTitle="Our Journey"/>
    <div className="maindiv standard-width">
        <h1 className="page-heading">Timeline</h1>
        <div className="page-description">
            <p>
                Here you can see some of the most memorable dates of our journey!
            </p>
        </div>
        <div className="timeline-container">
            {props.timelineEntries 
            ? props.timelineEntries.map((entry) => {
                return (<React.Fragment key={entry.slug.current}>
                <TimelineEntry
                title={entry.title}
                body={toHTML(entry.body)}
                image={entry.image}
                date={entry.date}
                videoId={entry.videoLink && (entry.videoLink.includes("watch") ? entry.videoLink.split("watch?v=") : entry.videoLink.split("youtu.be/"))[1]}
                // colorMain={entry.colorMain && entry.colorMain.hex}
                // colorSecondary={entry.colorSecondary && entry.colorSecondary.hex}
                idol={entry.idol}
                imageCaption={entry.imageCaption}
                imageStyle={entry.imageStyle}
                />
                </React.Fragment>)

            })
            : <LoadingSpinner/>}
            <div style={{flexBasis:"100%", height:0}}/>
            <div hidden={!props.showLoadMore}><LoadingSpinner className="new-row"/></div>
            {/* <button hidden={!props.showLoadMore} onClick={props.onLoadMore}>Load more</button> */}
        </div>
    </div></>)
}